export default {"src":"/planos/_next/static/media/equifax-report.1e65625b.svg","height":18,"width":16,"blurWidth":0,"blurHeight":0};